export default __webpack_public_path__ + "static/media/LetsGo_05.e076dd97.png";